import clsx from "clsx";
import { useState } from "react";

export interface TagsProps {
  tags: string[];
  lengthShown?: number;
  className?: string;
}

export function Tags(props: TagsProps) {
  const { tags, lengthShown = 3, className } = props;
  const [showAll, setShowAll] = useState(false);

  const handleToggle = () => setShowAll((prev) => !prev);

  const visibleTags = showAll ? tags : tags.slice(0, lengthShown);
  const remainingCount = tags.length - lengthShown;

  return (
    <div className={clsx("flex flex-wrap gap-1", className)}>
      {visibleTags.map((item, index) => (
        <span
          key={index}
          className="text-[11px] text-gray-extra-dark bg-gray-extra-light py-1 px-1.5"
        >
          {item}
        </span>
      ))}
      {!showAll && remainingCount > 0 && (
        <span
          onClick={handleToggle}
          className="text-[11px] cursor-pointer text-gray-extra-dark bg-gray-extra-light py-1 px-1.5"
        >
          +{remainingCount}
        </span>
      )}
    </div>
  );
}

export default Tags;
